import React, { useEffect, useCallback, useState} from 'react';
import {DOT, DASH, VARIABLE} from 'effects/midi/tidal/types.js';
import CellInner from "components/effects/jaki/CellInner.js";
import {connect} from 'react-redux';

const Cell = ({
    mode,
    selected,
    cell,
    odd,
    x,
    y,
    grid,
    selection,
    setSelection,
    dragging,
    setDragging
}) => { 
    let [on, setOn] = useState(cell);
    let className = odd ? "cell odd" : "cell";
    if (on) {
        className += " on";
    }

    useEffect(() => {
        setOn(cell);
    }, [cell, setOn]);

    const onClick = useCallback(() => {
        let _cell = undefined;
        if (on) {
            _cell = false;
            grid.set(x, y, false);
        } else {
            _cell = mode;
            grid.set(x, y, mode);
        }
        setOn(_cell);
    }, [mode, setOn, on, x, y]);

    const onMouseDown = useCallback(() => {
        if (on) {
            setDragging({x,y});
        } else {
            setSelection({
                x1: x, y1: y, x2: x, y2: y
            });
        }
    }, [on, selection, setSelection, setDragging]);

    const onMouseOver = useCallback(() => {
        if (dragging) {
            if (grid.drag(dragging.x, dragging.y, x, y)) {
                setDragging({x,y});
            }
        } else if (selection) {
            setSelection({
                ...selection,
                x2: x,
                y2: y
            });
        }
    }, [selection, dragging, setDragging, setSelection]);

    if (selection) {
        if (x >= selection.x1 && x <= selection.x2 &&
            y >= selection.y1 && y <= selection.y2) {
            className += " selection";
        }
    }

    if (selected) {
        className += " selected";
    }

    if (on === DASH) {
        className += " dash";
    }

    if (on === DOT) {
        className += " dot";
    }

    return (
        <div
          onMouseUp={() => setDragging(undefined)}
          onMouseDown={onMouseDown}
          onMouseOver={onMouseOver}
          onClick={onClick}
          className={className}>
          {on === DASH ?
           <div className="dash-inner">
             <CellInner cell={on}/>
           </div> :
           <CellInner cell={on}/>
          }
        </div>);
}

const mapStateToProps = (state, props) => {
    return {
        cell: props.grid.cells[props.y][props.x]
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cell);
